var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"qr-code-modal","title":_vm.$t('contract.qr_code'),"ok-only":"","ok-title":_vm.$t('generals.close'),"size":"lg"}},[_c('b-img',{staticClass:"w-100",attrs:{"src":_vm.photo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }